<template>
  <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow" :custom-tag="fromFooter ? 'li' : 'span'">
    <SmartLinkStandaloneElement :codename="typ.elements.label.codename" class="contact-item phone-number">
      <span>
        <font-awesome class="contact-icon fa-fw" icon="phone" v-if="data.showIcon"/>
      </span>
      <span v-if="data.label" class="contact-label">{{ data.label }}</span>
      <span>
        <a class="contact-link" :href="`tel:${data.phone}`">{{ data.phone }}</a>
      </span>
    </SmartLinkStandaloneElement>
  </SmartLinkItemComponent>
</template>
<script lang="ts" setup>
import type { IContentItem } from '@kontent-ai/delivery-sdk'
import type { ContactItemPhoneModel } from '~/models'
import { contentTypes } from '~/models'
const typ = contentTypes._contact_item__phone__

const props = defineProps<{ model: IContentItem, fromFooter: boolean }>()
const model = props.model as ContactItemPhoneModel
const data = {
  label: model.elements.label.value,
  phone: model.elements.phone.value,
  showIcon: multipleChoiceToBoolean(model.elements.showIcon)
}
</script>
